import React from "react";
import Image from "next/image";
import { LoginImg } from "../assets";

type MainLoginProps = {
    onTeacherLoginClick?: () => void;
};

export default function MainLogin({ onTeacherLoginClick }: MainLoginProps) {
    const handleOpenStudentLogin = () => {
        window.open(
            "https://login.pilaproject.org/?redirect_uri=https%3A%2F%2Fauth.knowlearning.systems%2F&response_type=code&nonce=y0dtq3b1gk&state=947opnr33ab&origin=https%3A%2F%2Fthailand.pilaproject.org%2F",
            "_blank",
            "noopener,noreferrer"
        );
    };

    const handleOpenThaiPilaPlatform = () => {
        window.open(
            "https://thailand.pilaproject.org/teacher/classes",
            "_blank",
            "noopener,noreferrer"
        );
    };

    return (

        <div className="min-h-screen bg-[#F4F3ED] flex items-center justify-center">

            <div className="bg-white rounded-2xl shadow-[0_8px_30px_rgb(0,0,0,0.08)] flex flex-col md:flex-row w-full max-w-4xl overflow-hidden min-h-[700px]">

                <div className="relative w-full md:w-1/2 hidden md:block">
                    <Image
                        src={LoginImg}
                        alt="THAI PILA Illustration"
                        fill
                        className="object-cover"
                        priority
                    />
                </div>

                <div className="w-full md:w-1/2 p-8 md:p-12 flex flex-col items-center justify-center">

                    <h1 className="text-2xl font-bold text-gray-900 mb-6">
                        เข้าสู่ระบบ
                    </h1>

                    <div className="text-center mb-8">
                        <h2 className="text-[#007FC3] font-bold text-2xl mb-1">
                            ยินดีต้อนรับสู่ THAI PILA!
                        </h2>
                        <p className="text-[#007FC3] font-bold text-2xl">
                            บอกให้เรารู้ว่าคุณเป็นใคร?
                        </p>
                    </div>

                    <div className="w-full max-w-90 flex flex-col gap-6">

                        <button
                            type="button"
                            onClick={handleOpenStudentLogin}
                            className="w-full bg-[#FCE654] hover:bg-[#F5DF4D] text-gray-900 font-semibold py-4 px-6 rounded-md transition-colors shadow-sm text-xl cursor-pointer"
                        >
                            นักเรียน
                        </button>

                        <button
                            type="button"
                            onClick={handleOpenThaiPilaPlatform} // onTeacherLoginClick
                            className="w-full bg-[#FCE654] hover:bg-[#F5DF4D] text-gray-900 font-semibold py-4 px-6 rounded-md transition-colors shadow-sm text-xl cursor-pointer"
                        >
                            ครู/อาจารย์
                        </button>

                        <button
                            type="button"
                            onClick={onTeacherLoginClick} // handleOpenThaiPilaPlatform
                            className="w-full bg-[#FCE654] hover:bg-[#F5DF4D] text-gray-900 font-semibold py-4 px-6 rounded-md transition-colors shadow-sm text-xl cursor-pointer"
                        >
                            แพลตฟอร์มกิจกรรม THAI PILA
                        </button>

                    </div>

                </div>
            </div>

        </div>
    );
}